import { render, staticRenderFns } from "./TrainingHistory.vue?vue&type=template&id=24b5bb01&scoped=true"
import script from "./TrainingHistory.vue?vue&type=script&lang=js"
export * from "./TrainingHistory.vue?vue&type=script&lang=js"
import style0 from "./TrainingHistory.vue?vue&type=style&index=0&id=24b5bb01&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "24b5bb01",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("D:\\a\\1\\s\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('24b5bb01')) {
      api.createRecord('24b5bb01', component.options)
    } else {
      api.reload('24b5bb01', component.options)
    }
    module.hot.accept("./TrainingHistory.vue?vue&type=template&id=24b5bb01&scoped=true", function () {
      api.rerender('24b5bb01', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/provider/trainingHistory/TrainingHistory.vue"
export default component.exports